import React from 'react';
import ReactDOM from 'react-dom/client';
import './Pulsar.css';
import Inicio from './Inicio';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Inicio />
  </React.StrictMode>
);


